import { render, staticRenderFns } from "./block-images.vue?vue&type=template&id=f0ca24e0"
import script from "./block-images.vue?vue&type=script&lang=js"
export * from "./block-images.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports